import styled from '@emotion/styled'
import { Box } from '@mui/material'
import { Tab, Tabs } from '@material-ui/core'
import { colors, typography } from '@resiliatech/birdsong'

export const GoalSectionsContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding-bottom: 24px;
`

export const MenuTabs = styled(Tabs)`
  color: ${colors.illustration.darkBlue};
  border-bottom: 1px solid ${colors.interactive.borderEnabledHoverGray};
  height: 100%;

  & .MuiTabs-indicator {
    background-color: ${colors.illustration.darkBlue};
  }
`

export const MenuTab = styled(Tab)`
  ${typography.down1.semiBoldSans}
  text-transform: none;

  & .MuiTab-wrapper {
    align-items: center;
    justify-content: flex-start;
  }

  &.MuiTab-root {
    min-width: 0;
    padding: 9px 16px;
  }
`

export const Details = styled(Box)`
  display: flex;
  gap: 24px;
  width: 100%;
`

export const SectionContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 24px;
`

export const HeaderContainer = styled(Box)`
  ${typography.up1.regularSerif}
`
